import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';

export default function CategoryPreview() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            精选分类
          </h2>
          <p className="text-foreground-600 mt-2 text-sm">五大核心知识板块，系统构建合规知识体系</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => {
            const count = articles.filter((a) => a.categorySlug === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-xl p-6 border border-background-200 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 mb-4">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{count} 篇文章</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap">
                    查看分类 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}